import secureStorage from "../../../services/secureStorage";
import {
  SS_ADMIN_ID,
  SS_EMAIL,
  SS_INTERNAL,
  SS_REF_HASH_ID,
  SS_ROLE,
  SS_USER_HASH_ID
} from "../../../utility/constants/secureStorageManager";
import {
  ADMIN,
  ADMIN_USER,
  CLIENT,
  FINANCE,
  OPERATIONS,
  RESELLER,
  RNC,
  SALES,
  SUPPORT
} from "../../../utility/constants/valueConstants";
import {
  ApiGetServiceWithoutAuthenticationWrapper,
  ApiGetServiceWrapper,
  ApiGetServiceWrapperBlob,
  ApiGetServiceWrapperText
} from "../wrapperService";
import { API_ENDPOINT } from "./ApiEndpoint";

const roles = secureStorage.getItem(SS_ROLE);

export const ApiRequestGet = {
  getAllClientList: ({ status = "" }) => {
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          status
        },
        url: API_ENDPOINT.core_url + "client/onboard/approove/list"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllDeactivatedClientList: ({ status = "", userId = "" }) => {
    return new Promise((resolve, reject) => {
      const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
      const role = secureStorage.getItem(SS_ROLE);
      const email = secureStorage.getItem(SS_EMAIL);
      ApiGetServiceWrapper({
        headers: {
          status,
          userId: userId !== "" ? userId : role === ADMIN ? "" : ss_id,
          userRefId: ss_id,
          email: email
        },
        url: API_ENDPOINT.core_url + "client/deactivate/list"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  downloadVanTransaction: ({
    page = "",
    dateRange = "",
    size = "",
    status = "",
    keyWord = "",
    name = "",
    van = "",
    business = "",
    clientHashId,
    programId = "",
    serviceProviderType = "",
    rootReferenceId = "",
    resellerId = "",
    email = ""
  }) => {
    return new Promise((resolve, reject) => {
      const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
      const role = secureStorage.getItem(SS_ROLE);
      const internal = secureStorage.getItem(SS_INTERNAL);

      ApiGetServiceWrapper({
        headers: {
          page,
          size,
          dateRange,
          status,
          keyWord,
          name,
          van,
          business,
          clientHashId: role === CLIENT ? ss_id : clientHashId,
          program_id: programId,
          serviceProviderType: serviceProviderType,
          client_id: role === CLIENT ? ss_id : "",
          type: internal ? "internal" : "external",
          rootReferenceId:
            rootReferenceId !== ""
              ? rootReferenceId
              : role === SALES
              ? ss_id
              : "",
          userId: ss_id,
          role: role,
          resellerId:
            resellerId !== "" ? resellerId : role === RESELLER ? ss_id : "",
          created_by: role === SALES ? ss_id : "",
          initiatedBy: ss_id ?? "",
          email: email
        },
        body: {},

        url:
          API_ENDPOINT.core_url + "client/equitas/client/transaction/download"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllDashboardVolumeCount: ({
    clientId = "",
    resellerId = "",
    rootReferenceId = "",
    dateRange = "",
    serviceProviderName = ""
  }) => {
    return new Promise(async (resolve, reject) => {
      const role = await secureStorage.getItem(SS_ROLE);
      const ss_id = await secureStorage.getItem(SS_USER_HASH_ID);
      ApiGetServiceWrapper({
        headers: {
          clientId: clientId !== "" ? clientId : role === CLIENT ? ss_id : "",
          resellerId:
            resellerId !== "" ? resellerId : role === RESELLER ? ss_id : "",
          rootReferenceId:
            rootReferenceId !== ""
              ? rootReferenceId
              : role === SALES
              ? ss_id
              : "",
          dateRange,
          serviceProviderName: serviceProviderName
        },
        url: API_ENDPOINT.core_url + "service/wallet/volume/count"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getAllDashboardTransactionCount: ({
    clientId = "",
    resellerId = "",
    rootReferenceId = "",
    dateRange = "",
    serviceProviderName = ""
  }) => {
    return new Promise((resolve, reject) => {
      const role = secureStorage.getItem(SS_ROLE);
      const ss_id = secureStorage.getItem(SS_USER_HASH_ID);

      ApiGetServiceWrapper({
        headers: {
          clientId: clientId !== "" ? clientId : role === CLIENT ? ss_id : "",
          resellerId:
            resellerId !== "" ? resellerId : role === RESELLER ? ss_id : "",
          rootReferenceId:
            rootReferenceId !== ""
              ? rootReferenceId
              : role === SALES
              ? ss_id
              : "",
          dateRange,
          serviceProviderName: serviceProviderName
        },
        url: API_ENDPOINT.core_url + "service/wallet/transaction/count"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // getAllDashboardTransactionCount: ({
  //   clientId = "",
  //   resellerId = "",
  //   rootReferenceId = "",
  //   dateRange = "",
  //   serviceProviderName = "",
  // }) => {
  //   return new Promise((resolve, reject) => {
  //     const role = secureStorage.getItem(SS_ROLE);
  //     const ss_id = secureStorage.getItem(SS_USER_HASH_ID);

  //     ApiGetServiceWrapper({
  //       headers: {
  //         clientId: clientId !== "" ? clientId : role === CLIENT ? ss_id : "",
  //         resellerId:
  //           resellerId !== "" ? resellerId : role === RESELLER ? ss_id : "",
  //         rootReferenceId:
  //           rootReferenceId !== ""
  //             ? rootReferenceId
  //             : role === SALES
  //             ? ss_id
  //             : "",
  //         dateRange,
  //         serviceProviderName: serviceProviderName,
  //       },
  //       url: API_ENDPOINT.core_url + "service/wallet/transaction/count",
  //     })
  //       .then((response) => {
  //         resolve(response);
  //       })
  //       .catch((error) => {
  //         reject(error);
  //       });
  //   });
  // },

  getSettlementCount: ({
    dateRange = "",
    userId = "",
    serviceType = "",
    userRefId = "",
    rootReferenceId = "",
    serviceProviderName = ""
  }) => {
    return new Promise((resolve, reject) => {
      const role = secureStorage.getItem(SS_ROLE);
      const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
      const ss_ref_id = secureStorage.getItem(SS_REF_HASH_ID);

      ApiGetServiceWrapper({
        headers: {
          user_id: userId !== "" ? userId : role === CLIENT ? ss_id : "",
          user_ref_id:
            userRefId !== "" ? userRefId : role === RESELLER ? ss_id : "",
          daterange: dateRange,
          service_type: serviceType,
          root_ref_id:
            rootReferenceId !== ""
              ? rootReferenceId
              : role === SALES
              ? ss_id
              : "",
          serviceProviderName
        },
        url: API_ENDPOINT.core_url + "finance/settlement/count"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getClientBalance: ({ id = "", userRefId = "", serviceprovidername = "" }) => {
    return new Promise((resolve, reject) => {
      const role = secureStorage.getItem(SS_ROLE);
      const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
      const res_id = secureStorage.getItem(SS_REF_HASH_ID);
      const root_id = secureStorage.getItem(SS_ADMIN_ID);

      ApiGetServiceWrapper({
        headers: {
          userId: id ? id : role === CLIENT ? ss_id : "",
          resellerId: userRefId ? userRefId : role === RESELLER ? res_id : "",
          createdBy: role === ADMIN || role === ADMIN_USER ? "" : root_id,
          serviceprovidername
        },
        url: API_ENDPOINT.core_url + "service/client/balance"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getClientVouchertBalance: ({
    id = "",
    userRefId = "",
    serviceprovidername = ""
  }) => {
    return new Promise((resolve, reject) => {
      const role = secureStorage.getItem(SS_ROLE);
      const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
      const res_id = secureStorage.getItem(SS_REF_HASH_ID);
      const root_id = secureStorage.getItem(SS_ADMIN_ID);

      ApiGetServiceWrapper({
        headers: {
          userId: id ? id : role === CLIENT ? ss_id : "",
          resellerId: userRefId ? userRefId : role === RESELLER ? ss_id : "",
          // createdBy: role === ADMIN || role === ADMIN_USER ? "" : root_id,
          serviceprovidername
        },
        url: API_ENDPOINT.core_url + "service/client/voucher/balance"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getPayoutClientBalance: ({ id = "", userRefId = "" }) => {
    return new Promise((resolve, reject) => {
      const role = secureStorage.getItem(SS_ROLE);
      const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
      const res_id = secureStorage.getItem(SS_REF_HASH_ID);
      const root_id = secureStorage.getItem(SS_ADMIN_ID);

      ApiGetServiceWrapper({
        headers: {
          userId: id ? id : role === CLIENT ? ss_id : "",
          resellerId: userRefId ? userRefId : role === RESELLER ? res_id : "",
          createdBy: role === ADMIN || role === ADMIN_USER ? "" : root_id
        },
        url: API_ENDPOINT.core_url + "service/client/payout/balance"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getResellerList: () => {
    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
    const role = secureStorage.getItem(SS_ROLE);

    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          userRefId:
            role === ADMIN ||
            role === ADMIN_USER ||
            role === OPERATIONS ||
            role === SUPPORT ||
            role === OPERATIONS ||
            role === FINANCE ||
            role === RNC
              ? ""
              : ss_id
        },
        url: API_ENDPOINT.core_url + "reseller/fetch"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getSalesList: ({ userRefId }) => {
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          userRefId: userRefId
        },
        url: API_ENDPOINT.core_url + "get/sales"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getAllRoleCounts: ({ clientId = "" }) => {
    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
    const role = secureStorage.getItem(SS_ROLE);

    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          rootReferenceId:
            role === ADMIN ||
            role === ADMIN_USER ||
            role === SUPPORT ||
            role === FINANCE ||
            role === OPERATIONS ||
            role === RNC
              ? ""
              : role !== RESELLER
              ? ss_id
              : "",

          resellerRefId: role === RESELLER ? ss_id : ""
        },

        url: API_ENDPOINT.core_url + "roles/counts"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllRolesList: () => {
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {},

        url: API_ENDPOINT.core_url + "fetch/all/roles"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getCommissionList: ({ page = 1, size = 10 }) => {
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          page,
          size
        },

        url: API_ENDPOINT.core_url + "fetch/commission/list"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getClientListWithId: ({
    isForDropdown = false,
    userRefId,
    serviceType = ""
  }) => {
    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
    const role = secureStorage.getItem(SS_ROLE);

    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          isForDropdown,
          // userrefId: roles === RESELLER ? ss_id : "",
          rootReferenceId:
            role === ADMIN ||
            role === ADMIN_USER ||
            role === OPERATIONS ||
            role === SUPPORT ||
            role === OPERATIONS ||
            role === FINANCE ||
            role === RNC
              ? ""
              : role !== RESELLER
              ? ss_id
              : "",

          userrefId: userRefId
            ? userRefId
            : role === ADMIN ||
              role === ADMIN_USER ||
              role === OPERATIONS ||
              role === SUPPORT ||
              role === OPERATIONS ||
              role === FINANCE
            ? ""
            : role === RESELLER
            ? ss_id
            : "",
          serviceType
        },
        url: API_ENDPOINT.core_url + "client/fetch"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getAllServiceProviderList: ({ type = "" }) => {
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          type: type
        },
        url: API_ENDPOINT.core_url + "service/fetch/list"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllAclForUi: () => {
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          type: "ui"
        },
        url: API_ENDPOINT.user_service_url + "fetch/acl"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getAllUserList: (page, size) => {
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          page,
          size
        },
        url: API_ENDPOINT.core_url + "admin/list"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getVanDashboardValues: (
    daterange,
    userId,
    serviceProviderType,
    program_id
  ) => {
    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
    const role = secureStorage.getItem(SS_ROLE);

    // const type = userType === 'client' ?

    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          dateRange: daterange,
          //"client-Hash-Id": userId ? userId : role === CLIENT ? ss_id : "",
          program_id: role === CLIENT ? program_id : "",
          client_id: userId ? userId : role === CLIENT ? ss_id : "",
          serviceProviderType
        },
        body: {},
        url: API_ENDPOINT.core_url + "client/transaction/dashboard"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getVanDashboardVolume: (
    daterange,
    userId,
    serviceProviderType,
    program_id
  ) => {
    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
    const role = secureStorage.getItem(SS_ROLE);

    // const type = userType === 'client' ?

    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          dateRange: daterange,
          // "client-Hash-Id": userId ? userId : role === CLIENT ? ss_id : "",
          program_id: role === CLIENT ? program_id : "",
          client_id: userId ? userId : role === CLIENT ? ss_id : "",
          serviceProviderType
        },
        body: {},
        url: API_ENDPOINT.core_url + "client/transaction/dashboardVolume"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getVanTransactionCount: (
    updatedYear,
    userId,
    serviceProviderType,
    programId
  ) => {
    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
    const role = secureStorage.getItem(SS_ROLE);
    const d = new Date();
    let year = d.getFullYear();

    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          year: updatedYear ? updatedYear : year,
          client_id: userId ? userId : role === CLIENT ? ss_id : "",
          serviceProviderType,
          program_id: role === CLIENT ? programId : ""
        },
        body: {},
        url: API_ENDPOINT.core_url + "client/count/dash-board"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getVanTransactionVolume: (updatedYear, userId, programId) => {
    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
    const role = secureStorage.getItem(SS_ROLE);
    const d = new Date();
    let year = d.getFullYear();
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          year: updatedYear ? updatedYear : year,
          "client-Hash-Id": userId ? userId : role === CLIENT ? ss_id : "",
          program_id: role === CLIENT ? programId : "",
          client_id: role === CLIENT ? ss_id : ""
        },
        body: {},
        url: API_ENDPOINT.core_url + "client/equitas/transaction/volume"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  createNewToken: ({ token }) => {
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          Authorization: "Bearer " + token
        },
        url: API_ENDPOINT.user_service_url + "authentication/token/create"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  downloadTransaction: ({
    dateRange = "",
    clientId = "",
    resellerId = "",
    status = "",
    serviceType = "",
    rootReferenceId = "",
    serviceProviderName = "",
    van = "",
    email = "",
    mechanism = ""
  }) => {
    return new Promise((resolve, reject) => {
      const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
      const role = secureStorage.getItem(SS_ROLE);
      ApiGetServiceWrapper({
        headers: {
          dateRange,
          clientId: clientId !== "" ? clientId : role === CLIENT ? ss_id : "",
          resellerId:
            resellerId !== "" ? resellerId : role === RESELLER ? ss_id : "",
          status,
          serviceType,
          rootReferenceId:
            rootReferenceId !== ""
              ? rootReferenceId
              : role === SALES
              ? ss_id
              : "",
          serviceProviderName,
          userId: ss_id,
          role: role,
          van,
          email,
          mechanism: mechanism
        },

        url: API_ENDPOINT.core_url + "download/transaction/report"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  downloadVanCustomerList: ({
    page = 0,
    dateRange = "",
    size = 10,
    customerHashId = "",
    keyWord = "",
    van = "",
    name = "",
    status
  }) => {
    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
    const role = secureStorage.getItem(SS_ROLE);
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapperBlob({
        headers: {
          page,
          dateRange,
          size,
          customerHashId,
          keyWord,
          van,
          name,
          status,
          clientHashId: role === CLIENT ? ss_id : ""
        },

        url:
          API_ENDPOINT.core_url + "client/equitas/client/customerlist/download"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  downloadVanCustomerList: ({
    page = "",
    size = "",
    dateRange = "",
    //customerHashId = "",
    keyWord = "",
    van = "",
    name = "",
    status = "",
    clientHashId = "",
    programId = "",
    serviceProviderType = ""
  }) => {
    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
    const role = secureStorage.getItem(SS_ROLE);
    const internal = secureStorage.getItem(SS_INTERNAL);
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapperBlob({
        headers: {
          page,
          size,
          dateRange,
          //customerHashId,
          keyWord,
          van,
          name,
          status,
          clientHashId: role === CLIENT ? ss_id : clientHashId,
          program_id: programId,
          serviceProviderType: serviceProviderType,
          client_id: role === CLIENT ? ss_id : "",
          type: internal ? "internal" : "external"
        },
        body: {},

        url:
          API_ENDPOINT.core_url + "client/equitas/client/customerlist/download"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  downloadClientList: ({
    page = 0,
    dateRange = "",
    size = 10,
    onBoardedStatus = "",
    activeStatus,
    userId = "",
    userRefId = "",
    serviceType = "",
    serviceProviderName = ""
  }) => {
    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
    const role = secureStorage.getItem(SS_ROLE);
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapperBlob({
        headers: {
          page,
          dateRange,
          size,
          onBoardedStatus,
          activeStatus,
          userId,
          userRefId: userRefId
            ? userRefId
            : role === ADMIN ||
              role === ADMIN_USER ||
              role === OPERATIONS ||
              role === SUPPORT
            ? ""
            : role === RESELLER
            ? ss_id
            : "",
          serviceType,
          serviceProviderName,
          rootReferenceId:
            role === ADMIN ||
            role === ADMIN_USER ||
            role === OPERATIONS ||
            role === SUPPORT ||
            role === RNC ||
            role === FINANCE
              ? ""
              : role !== RESELLER
              ? ss_id
              : ""
        },

        url: API_ENDPOINT.core_url + "download/client/report"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  downloadSettlementList: ({
    dateRange = "",
    startDate = "",
    endDate = "",
    userId = "",
    userRefId = "",
    serviceType = "",
    status = "",
    rootReferenceId = ""
  }) => {
    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
    const role = secureStorage.getItem(SS_ROLE);
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapperBlob({
        headers: {
          dateRange,
          startDate,
          endDate,
          userId: userId !== "" ? userId : role === CLIENT ? ss_id : "",
          userRefId:
            userRefId !== "" ? userRefId : role === RESELLER ? ss_id : "",
          serviceType,
          status,
          rootreferenceid:
            rootReferenceId !== ""
              ? rootReferenceId
              : role === SALES
              ? ss_id
              : ""
        },

        url: API_ENDPOINT.core_url + "download/settlement/report"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  downloadRevenueList: ({
    dateRange = "",
    startDate = "",
    endDate = "",
    userId = "",
    userRefId = "",
    serviceType = "",
    status = "",
    rootReferenceId = ""
  }) => {
    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
    const role = secureStorage.getItem(SS_ROLE);
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapperBlob({
        headers: {
          dateRange,
          startDate,
          endDate,
          userId: userId !== "" ? userId : role === CLIENT ? ss_id : "",
          userRefId:
            userRefId !== "" ? userRefId : role === RESELLER ? ss_id : "",
          serviceType,
          status,
          rootreferenceid:
            rootReferenceId !== ""
              ? rootReferenceId
              : role === SALES
              ? ss_id
              : ""
        },

        url: API_ENDPOINT.core_url + "download/revenue/report"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(TypeError);
        });
    });
  },

  getSecretId: ({ id = "" }) => {
    return new Promise((resolve, reject) => {
      const ss_id = secureStorage.getItem(SS_USER_HASH_ID);

      ApiGetServiceWrapper({
        headers: {
          client_ref_id: ss_id
        },
        url: API_ENDPOINT.core_url + "client/fetch/secret"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getVanAccount: ({ id = "" }) => {
    return new Promise((resolve, reject) => {
      const ss_id = secureStorage.getItem(SS_USER_HASH_ID);

      ApiGetServiceWrapper({
        headers: {
          client_id: id ? id : ss_id
        },
        url: API_ENDPOINT.core_url + "prefund/fetch/account"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAclList: ({ user_id }) => {
    return new Promise((resolve, reject) => {
      // const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
      ApiGetServiceWrapper({
        headers: {
          user_id: user_id
        },
        url: API_ENDPOINT.user_service_url + "fetch/user/acl"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getTransactionLimit: ({ client_ref_id }) => {
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          client_ref_id: client_ref_id
        },
        url: API_ENDPOINT.core_url + "client/fetch/transaction/limit"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  fetchCommentsByRoomId: ({ roomid }) => {
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          roomid
        },
        url: API_ENDPOINT.core_url + "comment/fetch"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  fetchClientCurrentBalance: ({ client_secret, program_id }) => {
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          client_secret,
          program_id
        },
        url: API_ENDPOINT.base_url + "eq-svc/api/v1/external/client-acc-balance"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchZyroClientCurrentBalance: ({ client_secret, program_id }) => {
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          client_secret,
          program_id
        },
        url: API_ENDPOINT.base_url + "zo-svc/api/v1/external/client-acc-balance"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchAxisClientCurrentBalance: ({ client_secret, program_id }) => {
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          client_secret,
          program_id
        },
        url: API_ENDPOINT.base_url + "ax-svc/api/v1/external/client-acc-balance"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchIdfcClientCurrentBalance: ({ client_secret, program_id }) => {
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          client_secret,
          program_id
        },
        url: API_ENDPOINT.base_url + "id-svc/api/v1/external/client-acc-balance"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchZyroClientCurrentBalanceVan: ({ client_secret, program_id }) => {
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          client_secret,
          program_id
        },
        url: API_ENDPOINT.base_url + "zo-svc/api/v1/external/va/balance"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  fetchResellerServiceProvider: ({ servicetype = "" }) => {
    return new Promise((resolve, reject) => {
      const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
      ApiGetServiceWrapper({
        headers: {
          userid: ss_id,
          servicetype
        },
        url: API_ENDPOINT.core_url + "client/fetch/reseller/service/list"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchLogoUrlFromDomailUrl: ({ url }) => {
    return new Promise((resolve, reject) => {
      const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
      ApiGetServiceWithoutAuthenticationWrapper({
        headers: {
          url: url
        },
        url: API_ENDPOINT.core_url + "reseller/fetch/logo/url"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  CustomerListDownload: ({
    Daterange = "",
    Clienthashid = "",
    Status = "",
    Van = "",
    Resellerid = "",
    serviceProviderName = ""
  }) => {
    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
    const role = secureStorage.getItem(SS_ROLE);
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapperBlob({
        headers: {
          Daterange,
          Clienthashid:
            Clienthashid !== "" ? Clienthashid : role === CLIENT ? ss_id : "",
          Status,
          Van,
          Resellerid:
            Resellerid !== "" ? Resellerid : role === RESELLER ? ss_id : "",
          createdBy: role === SALES ? ss_id : "",
          serviceProviderName,
          role: role
        },
        url: API_ENDPOINT.core_url + "client/customer/list/download"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  verifyToken: ({ token }) => {
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          Authorization: "Bearer " + token
        },
        url: API_ENDPOINT.user_service_url + "authentication/token/verify"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchUserLogs: ({ userId, page, size }) => {
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          userId,
          page,
          size
        },
        url: API_ENDPOINT.base_url + "user-svc/api/v1/logs/list"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchCashfreeClientCurrentBalance: ({ clientId: client_secret }) => {
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        headers: {
          client_secret
        },
        url: API_ENDPOINT.cashfree_url + "/external/balance/check"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};
